// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-section-anchor{display:block;height:0;scroll-margin-top:155px}.profile-section-target{scroll-margin-top:155px}@media(max-width:992px){.profile-section-anchor,.profile-section-target{scroll-margin-top:225px}}@media(max-width:768px){.profile-section-anchor,.profile-section-target{scroll-margin-top:205px}}

.e2e_record_page {
  --record-accent: #2563eb;
  --record-soft: #eff6ff;
  max-width: 1220px;
  margin: 0 auto;
  padding-bottom: 30px;
  scroll-behavior: smooth;
  animation: e2eRecordIn .28s ease both;
}

.e2e_record_violet { --record-accent: #7c3aed; --record-soft: #f5f3ff; }
.e2e_record_amber { --record-accent: #d97706; --record-soft: #fffbeb; }
.e2e_record_green { --record-accent: #059669; --record-soft: #ecfdf5; }

.e2e_record_back {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin: 4px 0 18px;
  padding: 10px 14px;
  border: 1px solid #dbe3ef;
  border-radius: 11px;
  background: #fff;
  color: #475569;
  font-weight: 750;
  cursor: pointer;
}

.e2e_record_back:hover { border-color: var(--record-accent); color: var(--record-accent); }

.e2e_record_hero {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 18px;
  padding: 26px;
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--record-accent) 22%, white);
  border-radius: 22px;
  background: linear-gradient(135deg, #fff 25%, var(--record-soft));
  box-shadow: 0 12px 36px rgba(15, 23, 42, .08);
}

.e2e_record_avatar {
  display: grid;
  width: 66px;
  height: 66px;
  place-items: center;
  border-radius: 18px;
  background: var(--record-accent);
  color: #fff;
  font-size: 27px;
  box-shadow: 0 10px 24px color-mix(in srgb, var(--record-accent) 28%, transparent);
}

.e2e_record_hero p {
  margin: 0 0 3px;
  color: var(--record-accent);
  font-size: 12px;
  font-weight: 850;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.e2e_record_hero h1 { margin: 0 0 6px; color: #172033; font-size: clamp(24px, 3vw, 34px); }
.e2e_record_hero span { color: #64748b; font-weight: 600; }

.e2e_record_status {
  padding: 9px 15px;
  border: 1px solid color-mix(in srgb, var(--record-accent) 30%, white);
  border-radius: 999px;
  background: #fff;
  color: var(--record-accent);
  font-size: 13px;
}

.e2e_record_quick_nav {
  position: sticky;
  z-index: 4;
  top: 0;
  display: flex;
  gap: 8px;
  margin: 16px 0;
  padding: 10px;
  overflow-x: auto;
  border: 1px solid #e8edf4;
  border-radius: 14px;
  background: rgba(255, 255, 255, .94);
  backdrop-filter: blur(12px);
}

.e2e_record_quick_nav a {
  flex: 0 0 auto;
  padding: 8px 12px;
  border-radius: 9px;
  color: #475569;
  font-size: 13px;
  font-weight: 750;
  text-decoration: none;
}

.e2e_record_quick_nav a:hover { background: var(--record-soft); color: var(--record-accent); }

.e2e_record_card {
  margin-bottom: 16px;
  padding: 24px;
  scroll-margin-top: 80px;
  border: 1px solid #e8edf4;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 5px 20px rgba(15, 23, 42, .045);
}

.e2e_record_card_title {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eef2f7;
  color: var(--record-accent);
}

.e2e_record_card_title > svg { margin-top: 4px; font-size: 19px; }
.e2e_record_card_title h2 { margin: 0 0 3px; color: #1e293b; font-size: 19px; }
.e2e_record_card_title p { margin: 0; color: #94a3b8; font-size: 13px; }

.e2e_record_grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin: 0;
}

.e2e_record_field {
  min-width: 0;
  padding: 15px;
  border: 1px solid #edf1f6;
  border-radius: 13px;
  background: #fbfcfe;
}

.e2e_record_field dt {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 7px;
  color: #8491a5;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.e2e_record_field dt svg { color: var(--record-accent); }
.e2e_record_field dd { margin: 0; overflow-wrap: anywhere; color: #283548; font-size: 14px; font-weight: 700; }

.e2e_record_notes {
  margin-bottom: 14px;
  padding: 16px;
  border-left: 4px solid var(--record-accent);
  border-radius: 0 12px 12px 0;
  background: var(--record-soft);
}

.e2e_record_notes strong { color: #1e293b; }
.e2e_record_notes p { margin: 6px 0 0; color: #475569; line-height: 1.6; white-space: pre-wrap; }

.e2e_record_documents { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
.e2e_record_documents a {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 11px;
  padding: 15px;
  border: 1px solid #dfe7f1;
  border-radius: 13px;
  color: var(--record-accent);
  text-decoration: none;
  transition: .2s ease;
}
.e2e_record_documents a:hover { border-color: var(--record-accent); transform: translateY(-2px); box-shadow: 0 8px 18px rgba(15, 23, 42, .08); }
.e2e_record_documents span { display: flex; min-width: 0; flex-direction: column; }
.e2e_record_documents strong { overflow: hidden; color: #334155; text-overflow: ellipsis; white-space: nowrap; }
.e2e_record_documents small { margin-top: 3px; color: #94a3b8; }

.e2e_record_state {
  display: grid;
  min-height: 55vh;
  place-content: center;
  justify-items: center;
  padding: 30px;
  text-align: center;
  color: #475569;
}
.e2e_record_state h2 { margin: 15px 0 6px; color: #1e293b; }
.e2e_record_state p { margin: 0 0 18px; }
.e2e_record_state button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 15px;
  border: 1px solid #dbe3ef;
  border-radius: 10px;
  background: #fff;
  color: #2563eb;
  font-weight: 750;
  cursor: pointer;
}
.e2e_record_state > span { display: flex; gap: 9px; }
.e2e_record_error > div { display: grid; width: 62px; height: 62px; place-items: center; border-radius: 50%; background: #fef2f2; color: #dc2626; font-size: 26px; font-weight: 900; }
.e2e_record_spinner { width: 42px; height: 42px; border: 4px solid #dbeafe; border-top-color: #2563eb; border-radius: 50%; animation: e2eRecordSpin .8s linear infinite; }

@keyframes e2eRecordIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
@keyframes e2eRecordSpin { to { transform: rotate(360deg); } }

@media (max-width: 900px) {
  .e2e_record_grid, .e2e_record_documents { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 600px) {
  .e2e_record_hero { grid-template-columns: auto 1fr; padding: 18px; }
  .e2e_record_status { grid-column: 1 / -1; justify-self: start; }
  .e2e_record_grid, .e2e_record_documents { grid-template-columns: 1fr; }
  .e2e_record_card { padding: 18px; }
  .e2e_record_quick_nav { scrollbar-width: none; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/recordView.css"],"names":[],"mappings":"AAAA,wBAAwB,aAAa,CAAC,QAAQ,CAAC,uBAAuB,CAAC,wBAAwB,uBAAuB,CAAC,wBAAwB,gDAAgD,uBAAuB,CAAC,CAAC,wBAAwB,gDAAgD,uBAAuB,CAAC;;AAExT;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA,qBAAqB,wBAAwB,EAAE,sBAAsB,EAAE;AACvE,oBAAoB,wBAAwB,EAAE,sBAAsB,EAAE;AACtE,oBAAoB,wBAAwB,EAAE,sBAAsB,EAAE;;AAEtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,yBAAyB,kCAAkC,EAAE,2BAA2B,EAAE;;AAE1F;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,qEAAqE;EACrE,mBAAmB;EACnB,iEAAiE;EACjE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EACX,eAAe;EACf,iFAAiF;AACnF;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,sBAAsB,eAAe,EAAE,cAAc,EAAE,iCAAiC,EAAE;AAC1F,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;;AAE1D;EACE,iBAAiB;EACjB,qEAAqE;EACrE,oBAAoB;EACpB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,aAAa;EACb,QAAQ;EACR,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,gCAAgC,8BAA8B,EAAE,2BAA2B,EAAE;;AAE7F;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,+BAA+B,eAAe,EAAE,eAAe,EAAE;AACjE,4BAA4B,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC9E,2BAA2B,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEvE;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,2BAA2B,2BAA2B,EAAE;AACxD,uBAAuB,SAAS,EAAE,uBAAuB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAE9G;EACE,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,2BAA2B,cAAc,EAAE;AAC3C,sBAAsB,eAAe,EAAE,cAAc,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;;AAEhG,wBAAwB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE;AACpG;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;AACtB;AACA,gCAAgC,kCAAkC,EAAE,2BAA2B,EAAE,4CAA4C,EAAE;AAC/I,6BAA6B,aAAa,EAAE,YAAY,EAAE,sBAAsB,EAAE;AAClF,+BAA+B,gBAAgB,EAAE,cAAc,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC/G,8BAA8B,eAAe,EAAE,cAAc,EAAE;;AAE/D;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA,uBAAuB,kBAAkB,EAAE,cAAc,EAAE;AAC3D,sBAAsB,gBAAgB,EAAE;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA,2BAA2B,aAAa,EAAE,QAAQ,EAAE;AACpD,0BAA0B,aAAa,EAAE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACrL,sBAAsB,WAAW,EAAE,YAAY,EAAE,yBAAyB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,4CAA4C,EAAE;;AAEzK,yBAAyB,OAAO,UAAU,EAAE,0BAA0B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;AACvH,2BAA2B,KAAK,yBAAyB,EAAE,EAAE;;AAE7D;EACE,0CAA0C,gDAAgD,EAAE;AAC9F;;AAEA;EACE,mBAAmB,+BAA+B,EAAE,aAAa,EAAE;EACnE,qBAAqB,mBAAmB,EAAE,mBAAmB,EAAE;EAC/D,0CAA0C,0BAA0B,EAAE;EACtE,mBAAmB,aAAa,EAAE;EAClC,wBAAwB,qBAAqB,EAAE;AACjD","sourcesContent":[".profile-section-anchor{display:block;height:0;scroll-margin-top:155px}.profile-section-target{scroll-margin-top:155px}@media(max-width:992px){.profile-section-anchor,.profile-section-target{scroll-margin-top:225px}}@media(max-width:768px){.profile-section-anchor,.profile-section-target{scroll-margin-top:205px}}\n\n.e2e_record_page {\n  --record-accent: #2563eb;\n  --record-soft: #eff6ff;\n  max-width: 1220px;\n  margin: 0 auto;\n  padding-bottom: 30px;\n  scroll-behavior: smooth;\n  animation: e2eRecordIn .28s ease both;\n}\n\n.e2e_record_violet { --record-accent: #7c3aed; --record-soft: #f5f3ff; }\n.e2e_record_amber { --record-accent: #d97706; --record-soft: #fffbeb; }\n.e2e_record_green { --record-accent: #059669; --record-soft: #ecfdf5; }\n\n.e2e_record_back {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  margin: 4px 0 18px;\n  padding: 10px 14px;\n  border: 1px solid #dbe3ef;\n  border-radius: 11px;\n  background: #fff;\n  color: #475569;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.e2e_record_back:hover { border-color: var(--record-accent); color: var(--record-accent); }\n\n.e2e_record_hero {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 18px;\n  padding: 26px;\n  overflow: hidden;\n  border: 1px solid color-mix(in srgb, var(--record-accent) 22%, white);\n  border-radius: 22px;\n  background: linear-gradient(135deg, #fff 25%, var(--record-soft));\n  box-shadow: 0 12px 36px rgba(15, 23, 42, .08);\n}\n\n.e2e_record_avatar {\n  display: grid;\n  width: 66px;\n  height: 66px;\n  place-items: center;\n  border-radius: 18px;\n  background: var(--record-accent);\n  color: #fff;\n  font-size: 27px;\n  box-shadow: 0 10px 24px color-mix(in srgb, var(--record-accent) 28%, transparent);\n}\n\n.e2e_record_hero p {\n  margin: 0 0 3px;\n  color: var(--record-accent);\n  font-size: 12px;\n  font-weight: 850;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n}\n\n.e2e_record_hero h1 { margin: 0 0 6px; color: #172033; font-size: clamp(24px, 3vw, 34px); }\n.e2e_record_hero span { color: #64748b; font-weight: 600; }\n\n.e2e_record_status {\n  padding: 9px 15px;\n  border: 1px solid color-mix(in srgb, var(--record-accent) 30%, white);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--record-accent);\n  font-size: 13px;\n}\n\n.e2e_record_quick_nav {\n  position: sticky;\n  z-index: 4;\n  top: 0;\n  display: flex;\n  gap: 8px;\n  margin: 16px 0;\n  padding: 10px;\n  overflow-x: auto;\n  border: 1px solid #e8edf4;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, .94);\n  backdrop-filter: blur(12px);\n}\n\n.e2e_record_quick_nav a {\n  flex: 0 0 auto;\n  padding: 8px 12px;\n  border-radius: 9px;\n  color: #475569;\n  font-size: 13px;\n  font-weight: 750;\n  text-decoration: none;\n}\n\n.e2e_record_quick_nav a:hover { background: var(--record-soft); color: var(--record-accent); }\n\n.e2e_record_card {\n  margin-bottom: 16px;\n  padding: 24px;\n  scroll-margin-top: 80px;\n  border: 1px solid #e8edf4;\n  border-radius: 20px;\n  background: #fff;\n  box-shadow: 0 5px 20px rgba(15, 23, 42, .045);\n}\n\n.e2e_record_card_title {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #eef2f7;\n  color: var(--record-accent);\n}\n\n.e2e_record_card_title > svg { margin-top: 4px; font-size: 19px; }\n.e2e_record_card_title h2 { margin: 0 0 3px; color: #1e293b; font-size: 19px; }\n.e2e_record_card_title p { margin: 0; color: #94a3b8; font-size: 13px; }\n\n.e2e_record_grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n  margin: 0;\n}\n\n.e2e_record_field {\n  min-width: 0;\n  padding: 15px;\n  border: 1px solid #edf1f6;\n  border-radius: 13px;\n  background: #fbfcfe;\n}\n\n.e2e_record_field dt {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 7px;\n  color: #8491a5;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n\n.e2e_record_field dt svg { color: var(--record-accent); }\n.e2e_record_field dd { margin: 0; overflow-wrap: anywhere; color: #283548; font-size: 14px; font-weight: 700; }\n\n.e2e_record_notes {\n  margin-bottom: 14px;\n  padding: 16px;\n  border-left: 4px solid var(--record-accent);\n  border-radius: 0 12px 12px 0;\n  background: var(--record-soft);\n}\n\n.e2e_record_notes strong { color: #1e293b; }\n.e2e_record_notes p { margin: 6px 0 0; color: #475569; line-height: 1.6; white-space: pre-wrap; }\n\n.e2e_record_documents { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }\n.e2e_record_documents a {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  align-items: center;\n  gap: 11px;\n  padding: 15px;\n  border: 1px solid #dfe7f1;\n  border-radius: 13px;\n  color: var(--record-accent);\n  text-decoration: none;\n  transition: .2s ease;\n}\n.e2e_record_documents a:hover { border-color: var(--record-accent); transform: translateY(-2px); box-shadow: 0 8px 18px rgba(15, 23, 42, .08); }\n.e2e_record_documents span { display: flex; min-width: 0; flex-direction: column; }\n.e2e_record_documents strong { overflow: hidden; color: #334155; text-overflow: ellipsis; white-space: nowrap; }\n.e2e_record_documents small { margin-top: 3px; color: #94a3b8; }\n\n.e2e_record_state {\n  display: grid;\n  min-height: 55vh;\n  place-content: center;\n  justify-items: center;\n  padding: 30px;\n  text-align: center;\n  color: #475569;\n}\n.e2e_record_state h2 { margin: 15px 0 6px; color: #1e293b; }\n.e2e_record_state p { margin: 0 0 18px; }\n.e2e_record_state button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 15px;\n  border: 1px solid #dbe3ef;\n  border-radius: 10px;\n  background: #fff;\n  color: #2563eb;\n  font-weight: 750;\n  cursor: pointer;\n}\n.e2e_record_state > span { display: flex; gap: 9px; }\n.e2e_record_error > div { display: grid; width: 62px; height: 62px; place-items: center; border-radius: 50%; background: #fef2f2; color: #dc2626; font-size: 26px; font-weight: 900; }\n.e2e_record_spinner { width: 42px; height: 42px; border: 4px solid #dbeafe; border-top-color: #2563eb; border-radius: 50%; animation: e2eRecordSpin .8s linear infinite; }\n\n@keyframes e2eRecordIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }\n@keyframes e2eRecordSpin { to { transform: rotate(360deg); } }\n\n@media (max-width: 900px) {\n  .e2e_record_grid, .e2e_record_documents { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 600px) {\n  .e2e_record_hero { grid-template-columns: auto 1fr; padding: 18px; }\n  .e2e_record_status { grid-column: 1 / -1; justify-self: start; }\n  .e2e_record_grid, .e2e_record_documents { grid-template-columns: 1fr; }\n  .e2e_record_card { padding: 18px; }\n  .e2e_record_quick_nav { scrollbar-width: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
